// @flow

import { oneOf } from 'common/json/extract';
import type { JSONValue } from 'common/types';
import { type Locale, locales } from 'common/types/locale';

export const locale: JSONValue => Locale = oneOf(locales);
